export default class CalculationError {
  contractId: string;

  contractNumber: string;

  createdDate: string;

  customerName: string;

  error: string;

  externalId: string;

  itemNumber: number;

  message: string;

  constructor(obj: any) {
    this.contractId = obj.contractId || '';
    this.contractNumber = obj.contractNumber || '';
    this.createdDate = obj.createdDate || '';
    this.customerName = obj.customerName || '';
    this.error = obj.error || '';
    this.externalId = obj.externalId || '';
    this.itemNumber = obj.itemNumber || '';
    this.message = obj.message || '';
  }

  static of(obj: any): CalculationError {
    return new CalculationError(obj);
  }

  static ofList(obj: any[]): CalculationError[] {
    return obj.map(this.of)
  }
}
